import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/base/Button";
import Card from "../../components/base/Card";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import HeroImage from "@/assets/images/about-hero.jpg";
import Project1Image from "@/assets/images/1-1Remodel.png";
import Project2Image from "../../assets/images/2Landscape Lighting.png";
import PortfolioSectionA from "../home/components/PortfolioSectionA";
import Rendering1 from "@/assets/images/3D/3d.png";
import LightingCoverageImg from "@/assets/images/lighting/lighting_cover.png";
import WifiCardImg from "@/assets/images/wifi/wifi.png";
import FlooPlan1 from "@/assets/images/floorplan/1.png";
import Lighting1 from "@/assets/images/lighting/Lighting.png";
import LineDiagram2 from "@/assets/images/linediagram/2.png";


export default function ServicesPage() {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const services = [
    {
      title: "Lighting Design & Analysis",
      description:
        "Precise 2D and 3D technical drawings, floor plans, and detailed engineering schematics for all project types with industry-standard accuracy.",
      image: Lighting1,
      features: [
        "2D Technical Drawings",
        "3D Modeling",
        "Engineering Schematics",
        "Precision Documentation",
      ],
    },

    {
      title: "Wifi Coverage",
      description:
        "Advanced Building Information Modeling (BIM) with photorealistic 3D renderings and parametric design capabilities for complex architectural projects.",
      image: WifiCardImg,
      features: ["BIM Modeling", "Photorealistic Renderings"],
    },
    {
      title: "3D Visualization & Renderings",
      description:
        "Professional lighting design and analysis using industry-standard Dialux software for optimal illumination and energy efficiency in all spaces.",
      image: Rendering1,
      features: [
        "Lighting Analysis",
        "Energy Efficiency",
        "Photometric Calculations",
        "Code Compliance",
      ],
    },
    {
      title: "Floor Plans",
      description:
        "Detailed architectural floor plans with accurate dimensions, furniture layouts, space optimization, and code compliance for residential and commercial projects.",
      image: FlooPlan1,
      features: [
        "Space Planning",
        "Furniture Layouts",
        "Code Compliance",
        "Dimension Accuracy",
      ],
    },
    {
      title: "Lighting Coverage",
      description: "photorealistic 3D renderings for Lighting",
      image: LightingCoverageImg,
      features: [
        "BIM Modeling",
        "Photorealistic Renderings",
        "Parametric Design",
        "Collaboration Tools",
      ],
    },
    {
      title: "Line Diagrams",
      description:
        "Technical line diagrams, electrical schematics, and system layouts for engineering projects with precise documentation and industry standards.",
      image: LineDiagram2,
      features: [
        "Electrical Schematics",
        "System Layouts",
        "Technical Documentation",
        "Industry Standards",
      ],
    },
  ];

  const projectHighlights = [
    {
      id: 1,
      title: "Modern Condo Interior Upgrade",
      category: "Lighting Design & Analysis",
      image: Project1Image,
    },
    {
      id: 2,
      title: "Landscape Lighting Layout",
      category: "Lighting Design & Analysis",
      image: Project2Image,
    },
  ];

  // const downloadableResources = [
  //   {
  //     title: 'AutoCAD Services Brochure',
  //     description: 'Comprehensive overview of our AutoCAD design capabilities',
  //     icon: 'ri-file-pdf-line'
  //   },
  //   {
  //     title: 'Revit & BIM Solutions',
  //     description: 'Detailed information about our 3D modeling services',
  //     icon: 'ri-file-pdf-line'
  //   },
  //   {
  //     title: 'Lighting Design Portfolio',
  //     description: 'Showcase of our Dialux lighting projects',
  //     icon: 'ri-file-pdf-line'
  //   },
  //   {
  //     title: 'Technical Services Guide',
  //     description: 'Complete guide to our floor plans and line diagram services',
  //     icon: 'ri-file-pdf-line'
  //   }
  // ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % projectHighlights.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + projectHighlights.length) % projectHighlights.length
    );
  };

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative py-20 bg-gradient-to-br from-[#dbcfbf]/30 to-white dark:from-slate-800/50 dark:to-slate-900 transition-colors duration-300">
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage: `url('${HeroImage}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#212026] dark:text-gray-100 mb-6 transition-colors duration-300">
              Our Design & Engineering Services
            </h1>
            <p className="text-xl md:text-2xl text-[#889d8f] dark:text-gray-300 max-w-4xl mx-auto transition-colors duration-300">
              Precision-driven design solutions for architects, contractors, and
              clients
            </p>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-20 bg-white dark:bg-slate-900 transition-colors duration-300">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <section className="py-20 dark:bg-slate-900 transition-colors duration-300">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {services.map((service, index) => (
                  <div key={index} className="perspective-1000 h-[400px]">
                    <div className="relative w-full h-full transition-transform duration-700 transform-style-3d group hover:[transform:rotateY(180deg)]">
                      {/* Front of card */}
                      <div className="absolute inset-0 backface-hidden">
                        <Card className="h-full overflow-hidden dark:bg-slate-800 border-gray-200 dark:border-slate-700 transition-colors duration-300">
                          <div className="relative h-full bg-[#dbcfbf]/10 dark:bg-slate-700/30">
                            <img
                              src={service.image}
                              alt={service.title}
                              className="w-full h-full object-cover object-top"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                              <h3 className="text-2xl font-bold text-white">
                                {service.title}
                              </h3>
                            </div>
                          </div>
                        </Card>
                      </div>

                      {/* Back of card */}
                      <div className="absolute inset-0 backface-hidden [transform:rotateY(180deg)]">
                        <Card className="h-full overflow-hidden dark:bg-slate-800 border-gray-200 dark:border-slate-700 transition-colors duration-300">
                          <div className="p-6 h-full flex flex-col justify-between">
                            <div>
                              <h3 className="text-xl font-bold text-[#F5A623] dark:text-[#F5A623] mb-3">
                                {service.title}
                              </h3>
                              <p className="text-[#889d8f] dark:text-gray-300 mb-4 leading-relaxed text-sm transition-colors duration-300">
                                {service.description}
                              </p>
                            </div>
                            <div>
                              <div className="flex flex-wrap gap-2">
                                {service.features.map((feature, idx) => (
                                  <span
                                    key={idx}
                                    className="text-xs px-2 py-1 bg-[#dbcfbf]/50 dark:bg-slate-700/50 text-[#212026] dark:text-gray-300 rounded-full transition-colors duration-300"
                                  >
                                    {feature}
                                  </span>
                                ))}
                              </div>
                            </div>
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <style>{`
                    .perspective-1000 {
                      perspective: 1000px;
                    }
                    .transform-style-3d {
                      transform-style: preserve-3d;
                    }
                    .backface-hidden {
                      backface-visibility: hidden;
                      -webkit-backface-visibility: hidden;
                    }
                  `}</style>
          </div>
        </section>

        {/* Service Categories */}
        <PortfolioSectionA/>

        {/* Downloadable Resources */}
        {/* <section className="py-20 bg-white dark:bg-slate-900 transition-colors duration-300">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-[#212026] dark:text-gray-100 mb-4 transition-colors duration-300">
                Downloadable Resources
              </h2>
              <p className="text-xl text-[#889d8f] dark:text-gray-300 max-w-3xl mx-auto transition-colors duration-300">
                Get detailed information about our services and capabilities
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {downloadableResources.map((resource, index) => (
                <Card key={index} className="text-center p-6 group bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 transition-colors duration-300">
                  <div className="w-16 h-16 bg-[#F5A623]/10 dark:bg-[#F5A623]/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-[#F5A623]/20 dark:group-hover:bg-[#F5A623]/30 transition-colors duration-300">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className={`${resource.icon} text-[#F5A623] text-2xl`}></i>
                    </div>
                  </div>
                  <h3 className="text-lg font-bold text-[#212026] dark:text-gray-100 mb-2 transition-colors duration-300">
                    {resource.title}
                  </h3>
                  <p className="text-[#889d8f] dark:text-gray-300 text-sm mb-4 transition-colors duration-300">
                    {resource.description}
                  </p>
                  <Button 
                    variant="outline" 
                    size="sm" 
                    className="border-[#F5A623] text-[#F5A623] hover:bg-[#F5A623] hover:text-white dark:border-[#F5A623] dark:text-[#F5A623] dark:hover:bg-[#F5A623] dark:hover:text-white transition-all duration-300"
                  >
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-download-line"></i>
                    </div>
                    Download PDF
                  </Button>
                </Card>
              ))}
            </div>
          </div>
        </section> */}

        {/* Call-to-Action */}
        <section className="py-20 bg-[#e18033] dark:bg-[#d16f29] transition-colors duration-300">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Need tailored design solutions? Let's build together.
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Ready to transform your architectural vision into reality with our
              precision engineering services?
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="/contact">
                <Button
                  variant="outline"
                  size="lg"
                  className="border-white text-white hover:bg-white hover:text-black dark:border-gray-300 dark:hover:bg-gray-300 dark:hover:text-slate-900 transition-all duration-300"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-phone-line"></i>
                  </div>
                  Contact Us
                </Button>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
